import { render, staticRenderFns } from "./salary-form.vue?vue&type=template&id=4c1e21b0"
import script from "./salary-form.vue?vue&type=script&lang=js"
export * from "./salary-form.vue?vue&type=script&lang=js"
import style0 from "./salary-form.vue?vue&type=style&index=0&id=4c1e21b0&prod&lang=scss"
import style1 from "./salary-form.vue?vue&type=style&index=1&id=4c1e21b0&prod&midia=print&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports